import { IApplicationState } from '../../types/redux';

export const selectSkipOffersFetch = (state: IApplicationState) => state.calculator.skipOffersFetch;
